import { createUseStyles } from 'react-jss'

export const useAutoOptimiseToggleLabelStyles = createUseStyles({
  autoOptimiseToggleLabel: {
    fontWeight: 700
  }
})

export default useAutoOptimiseToggleLabelStyles
